const CopyUrlMobile = ({ url, name, urlRef, copied, handleCopy }) => {
    return (
        <div className="d-sm-flex bg-gray-100 border-radius-lg p-2 my-2 align-items-center">
            <p className="text-sm font-weight-bold my-auto ps-sm-2 mb-2">
                {name}
            </p>

            <h6
                className="text-sm"
                ref={urlRef}
            >
                {url}
            </h6>

            <button
                className="btn btn-sm bg-gradient-dark my-sm-auto mt-2 mb-0 w-100"
                type="button"
                onClick={handleCopy}
            >
                <i className="material-icons text-sm me-1">
                    {copied ? "check_circle" : "content_copy"}
                </i>
                {copied ? "Copied" : "Copy"}
            </button>
        </div>
    );
}

export default CopyUrlMobile;